import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Blob } from 'node-fetch';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiModels, HttpService } from '@mona/api';
import { ReportLocation, ReportRequestBody, ReportTimePeriod, ReportType } from '@mona/models';
import {
    ApiLocation,
    ApiReport,
    transformApiReportLocations,
    transformApiReportTypes,
} from './transforms/reports.transform';

/**
 * API abstraction layer for the export reports list API
 */
@Injectable({
    providedIn: 'root',
})
export class ReportsApi {
    reportName = 'disaster_recovery';

    /**
     * Constructor
     *
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Loads reports list
     */
    loadReportsList(): Observable<ReportType[]> {
        return this.http
            .get<ApiReport[]>('/reporting-engine/list-reports')
            .pipe(map(results => transformApiReportTypes(results)));
    }

    /**
     * Load reports export locations
     */
    loadReportsExportLocations(): Observable<ReportLocation[]> {
        return this.http
            .get<ApiLocation[]>('/reporting-engine/store-locations')
            .pipe(map(results => transformApiReportLocations(results)));
    }

    /**
     * Loads report time periods
     */
    loadReportsTimePeriods(): Observable<ReportTimePeriod[]> {
        return this.http.get<ReportTimePeriod[]>('/reporting-engine/list-periods');
    }

    /**
     * Export full report
     *
     * @param requestBody
     * @param encounterId
     * @param timezone
     */
    exportReport(
        { reportLocation, reportType, ...requestBody }: ReportRequestBody,
        encounterId: string,
        timezone: string,
    ): Observable<{ message: string; task_id: string }> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
            }),
            responseType: 'blob',
        };

        return this.http.post(
            '/reporting-engine/generate-report',
            {
                output: reportLocation,
                timezone, // example: "Europe/Berlin",
                encounter: encounterId,
                background_generation: true,
                report: reportType,
                ...requestBody,
            },
            httpOptions,
        );
    }
}
